import { PHQ9_FORM_TITLE } from "../constants";

/**
 * test if the form is PHQ-9
 * Note: this is a short-term workaround, should improve the criteria in the future
 */
export default function isPHQ9Form(title?: string) {
  return title === PHQ9_FORM_TITLE;
}
